import React from 'react';
import { Form } from 'reactstrap';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";
import { resultStatus } from '../../../../constants/holcim';

import { BaseCustomButton, BaseSelectComponent, BaseCustomModal, GradientDecorationLine } from '../../../../shared';
import Base from 'antd/es/typography/Base';

export const StatusModal = ({ props, setShowModal, showModal, modalRespInfo, isUpdate, requestStatus }) => {

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            deliveryResultStatus: requestStatus?.deliveryResultStatus ?? '-',
        },
        validationSchema: Yup.object({
            deliveryResultStatus: Yup.string().required("Seleccione un área de laboratorio"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
            // dispatch(loginUser(values, props.history));
        }
    });

    const { className } = props;
    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () =>{
        validation.resetForm()
    }

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                icon="mdi mdi-content-save"
                isLoading={false}
                onClick={validation.handleSubmit}
                className="rounded-3 me-2"
                outline
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                icon="mdi mdi-close-circle-outline"
                isLoading={false}
                onClick={toggle}
                className="rounded-3 me-3"
                outline
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">Edición estatus de reporte final</h4>
            </label>
        </div>
    );


    return (
        <>
            <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                width="60%"
                className={className}
                footer={buttons} 
            >
                <GradientDecorationLine />

                <Form
                    className="form-horizontal mt-3 mb-1"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <div className="mb-1 px-5">
                        <label className="text-primary">Estatus de la Solicitud</label>
                        <BaseSelectComponent
                            disabled={isUpdate}
                            placeholder="Estatus de solicitud"
                            options={resultStatus.map((dir) => ({
                                value: dir.id,
                                label: dir.value,
                            }))}
                            value={validation.values.deliveryResultStatus || ''}
                            onChange={(val) => {
                                validation.setFieldValue('deliveryResultStatus', val);
                            }}
                            onBlur={() => validation.setFieldTouched('deliveryResultStatus', true)}
                            error={validation.errors.deliveryResultStatus}
                            touched={validation.touched.deliveryResultStatus}
                            status={validation.errors.deliveryResultStatus && validation.touched.deliveryResultStatus ? 'error' : ''}
                        />
                    </div>

                    <div className="mt-5">
                        <GradientDecorationLine />
                    </div>
                </Form>
            </BaseCustomModal>
        </>
    )

}
